import { render, staticRenderFns } from "./RouteItem.vue?vue&type=template&id=93638b42&scoped=true"
import script from "./RouteItem.vue?vue&type=script&lang=js"
export * from "./RouteItem.vue?vue&type=script&lang=js"
import style0 from "./RouteItem.vue?vue&type=style&index=0&id=93638b42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93638b42",
  null
  
)

export default component.exports